module.exports = __webpack_public_path__ + "img/me.c3e88d49.jpg";